export const PLAN_UPSELL_BANNER_EMPHASIZED_TEXT_CLASSNAME = 'text-[14px] leading-5 font-[650] tracking-[0px]';
export const PLAN_UPSELL_BANNER_SUBTLE_TEXT_CLASSNAME = 'text-[13px] leading-5 font-[450] tracking-[0px]';

interface PlanUpsellBannerProps {
    title: string;
    description: React.ReactNode;
    buttonLabel: string;
    onButtonClick: () => void;
    imgSrc?: string;
    backgroundColor?: string;
    loading?: boolean;
    titleClassName?: string;
    descriptionClassName?: string;
    onDismiss?: () => void;
}

export const PlanUpsellBanner = ({
    title,
    description,
    buttonLabel,
    onButtonClick,
    imgSrc,
    backgroundColor,
    loading,
    titleClassName = PLAN_UPSELL_BANNER_EMPHASIZED_TEXT_CLASSNAME,
    descriptionClassName = PLAN_UPSELL_BANNER_SUBTLE_TEXT_CLASSNAME,
    onDismiss,
}: PlanUpsellBannerProps) => {
    const textColorClassName = backgroundColor ? 'text-white' : '';

    return (
        <s-section padding="none">
            <div
                className={`hover-reveal-group relative flex flex-row items-center justify-between gap-2 ${textColorClassName}`}
                style={{
                    background: backgroundColor,
                    padding: '24px 16px',
                }}
            >
                {onDismiss && (
                    <div className="absolute top-1 right-1 hover-reveal">
                        <s-button
                            icon="x"
                            variant="tertiary"
                            tone="neutral"
                            onClick={onDismiss}
                            accessibilityLabel="Dismiss"
                        ></s-button>
                    </div>
                )}
                <div className={`flex flex-row items-center gap-2.5 ${textColorClassName}`}>
                    {imgSrc && <img src={imgSrc} alt="" className="h-6 w-6" />}

                    <div>
                        <div className={titleClassName}>{title}</div>
                        <div className={descriptionClassName}>{description}</div>
                    </div>
                </div>
                <div style={onDismiss ? { paddingRight: '32px' } : undefined}>
                    <s-button variant="primary" onClick={onButtonClick} loading={loading}>
                        {buttonLabel}
                    </s-button>
                </div>
            </div>
        </s-section>
    );
};
